import React, { useMemo } from 'react';
import { SensordataSTChartLine } from '../../../../../../../redux/monitoring/api/monitoring.model';
import { DataGrid } from '@mui/x-data-grid';
import _ from 'lodash';
import moment from 'moment';

interface AnalogTableProps {
  sensordata: SensordataSTChartLine[];
}
function AnalogTable({ sensordata }: AnalogTableProps) {
  const rows = useMemo(() => getAnalogRows(sensordata), [sensordata]);
  const columns = useMemo(
    () => [
      {
        field: 'timestamp',
        headerName: 'Timestamp',
        width: 200,
        renderCell: (params: any) => {
          return moment.unix(params.row.timestamp).format('L LTS');
        },
      },
      { field: 'value', headerName: 'Value', width: 120 },
      { field: 'deviceId', headerName: 'Commander ID', width: 150 },
      { field: 'deviceName', headerName: 'Device name', width: 180 },
      { field: 'channel', headerName: 'Channel', width: 120 },
      { field: 'unit', headerName: 'Unit', width: 100 },
      { field: 'controlunit', headerName: 'Control Unit ID', width: 150 },
      { field: 'controlunitName', headerName: 'Control Unit Name', width: 180 },
    ],
    [sensordata]
  );
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 25 },
        },
        sorting: { sortModel: [{ field: 'timestamp', sort: 'desc' }] },
      }}
      disableRowSelectionOnClick
      pageSizeOptions={[10, 25, 50, 100, 200, 500, 1000]}
    />
  );
}

const getAnalogRows = (sensordata: SensordataSTChartLine[]) => {
  return _.unionBy(
    sensordata.flatMap((channel) =>
      channel.data.map((dataPoint) => {
        return {
          id: `${channel.deviceId}-${channel.controlunit}-${channel.channel}-${dataPoint.timestamp}`,
          //   timestamp: moment.unix(dataPoint.timestamp).format('LLL'),\
          timestamp: dataPoint.timestamp,
          value: dataPoint.f ?? dataPoint.val,
          deviceId: channel.deviceId,
          deviceName: channel.deviceName,
          channel: channel.channel,
          unit: channel.unitString ?? channel.unit,
          controlunit: channel.controlunit,
          controlunitName: channel.controlunitName,
        };
      })
    ),
    'id'
  );
};

export default AnalogTable;
